import React, { createContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import Login from './layout/login/login';
// import Signup from './components/Signup/signup';
import Alphaanalyst from './components/alphaanalyst';
import RecentDevelopment from './components/askanalyst/recentdevelopment';
import Databank from './components/databank';
import TimeLine from './components/askanalyst/timeline';
import SiteMap from './components/sitemap';
import Result from './components/askanalyst/result';
import ResearchReport from './components/askanalyst/researchreport';
import ResearchReport2 from './components/researchreport2/home';
import AnalystCalls from './components/researchreport2/analystcalls';
import Balancesheet from './components/askanalyst/balancesheet';
import Incomestatement from './components/askanalyst/incomestatement';
import About from './components/about';
import Ratio from './components/askanalyst/ratio';
import Cashflow from './components/askanalyst/cashflow/index';
import Valuation from './components/askanalyst/valuation';
import Technical from './components/askanalyst/technical';
import Overview from './components/askanalyst/overview';
import Chemical from './components/Sector/chemical';
import OMC from './components/Publisher/omc';
import Currency from './components/economy/currency';
import market from './components/market';
import BOP from './components/Publisher/bop';
import Inflation from './components/Sector';
import EconomyCement from './components/Sector/Cement-sector';
import Steel from './components/Sector/steel';
import Cement from './components/Sector/cement';
import MB from './components/Publisher/morningbriefing';
import Energy from './components/Sector/energy';
import Reset from './components/ResetPassword/reset';
import Welcome from './layout/flowscreen/welcome';
import Expire from './layout/flowscreen/expire';
import ResetExpire from './layout/flowscreen/resetexpire';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Filling from './components/askanalyst/companyfilings';
import FinanicalReports from './components/askanalyst/financialreports';
import News from './components/askanalyst/news';
import Camparasion from './components/comparison/index';
import Portfolio from './components/Publisher/portfolio/index';
import AnalystBriefing from './components/media/analystbriefing/index';
import Coal from './components/Sector/coal';
import Features from './components/features';
// import Calculator from './components/calculator';
import PIBT from './components/Sector/pibt';
import Calculator from './components/calculator/salarytax';
import SPICalculator from './components/calculator/sipcalculator';
import Fertilizer from './components/Sector/Fertilizer-sector';
import Autos from './components/Sector/Auto-sector';
import FairMarket from './components/calculator/fair-market-pe';
import WellheadGasPrice from './components/calculator/wellhead-gas-price';
import MediaDetail from './components/media/mediadetail/index';
import SectorOMC from './components/Sector/Omc-sector';

const Currentprice = createContext();

function App(props) {
  return (
    <>
      <ToastContainer
        draggable={false}
        transition={Bounce}
        autoClose={5000}
        position="bottom-right"
      />

      <Currentprice.Provider value={{ name: 'sulaiman', fname: 'jawaid' }}>
        <Router>
          <Switch>
            {/* Commented out Sign In and Sign Up routes */}
            {/* <Route path="/" exact component={Login} /> */}
            {/* <Route path="/signup" exact component={Signup} /> */}

            <Route path="/" exact component={market} />

            <Route path="/welcome/:name?" component={Welcome} />
            <Route path="/expire" exact component={Expire} />
            <Route path="/reset_expire" exact component={ResetExpire} />
            <Route path="/reset_password/:token?" component={Reset} />
            <Route path="/about" exact component={About} />
            <Route path="/company" exact component={Overview} />
            <Route path="/company/result" exact component={Result} />
            <Route
              path="/company/balancesheet"
              exact
              component={Balancesheet}
            />
            <Route
              path="/company/incomestatement"
              exact
              component={Incomestatement}
            />
            <Route path="/company/ratio" exact component={Ratio} />
            <Route path="/company/cashflow" exact component={Cashflow} />
            <Route path="/company/valuation" exact component={Valuation} />
            <Route path="/sitemap" exact component={SiteMap} />
            <Route path="/company/technicals" exact component={Technical} />
            <Route path="/company/overview" exact component={Overview} />
            <Route
              path="/company/researchreport"
              exact
              component={ResearchReport}
            />
            <Route
              path="/researchreport/home"
              exact
              component={ResearchReport2}
            />
            <Route
              path="/researchreport/analystcalls"
              exact
              component={AnalystCalls}
            />
            <Route path="/company/timeline" exact component={TimeLine} />
            <Route path="/company/news" exact component={News} />
            {/* <Route path="/market" exact component={market} /> */}
            <Route path="/market/investment" exact component={Portfolio} />
            <Route path="/databank" exact component={Databank} />
            <Route path="/publisher/morningbriefing" exact component={MB} />
            <Route
              path="/comparison/:module/:type/:symbol/:description_id/"
              exact
              component={Camparasion}
            />
            <Route path="/publisher/investment" exact component={Portfolio} />
            <Route
              path="/company/recentdevelopment"
              exact
              component={RecentDevelopment}
            />
            <Route path="/financials" exact component={Alphaanalyst} />
            <Route path="/sector" exact component={Chemical} />
            <Route path="/sector/chemical" exact component={Chemical} />
            <Route path="/sector/steel" exact component={Steel} />
            <Route path="/sector/cement" exact component={EconomyCement} />
            <Route path="/sector/fertilizer" exact component={Fertilizer} />
            <Route path="/sector/autos" exact component={Autos} />
            <Route path="/sector/coal" exact component={Coal} />
            <Route path="/publisher/omc" exact component={OMC} />
            <Route path="/economy" exact component={Currency} />
            <Route path="/economy/currency" exact component={Currency} />
            <Route path="/economy/omc" exact component={OMC} />
            <Route path="/sector/energy/:sector" exact component={Energy} />
            <Route path="/publisher/bop" exact component={BOP} />
            <Route path="/publisher/inflation" exact component={Inflation} />
            <Route path="/economy/cement" exact component={EconomyCement} />
            <Route path="/company/filings" exact component={Filling} />
            <Route
              path="/company/financialreports"
              exact
              component={FinanicalReports}
            />
            <Route
              path="/media/analystbriefing"
              exact
              component={AnalystBriefing}
            />
            <Route path="/features" exact component={Features} />
            <Route path="/Sector/pibt" exact component={PIBT} />
            {/* <Route path="/calculator" exact component={Calculator} /> */}
            <Route path="/calculator/salarytax" exact component={Calculator} />
            <Route
              path="/calculator/sipcalculator"
              exact
              component={SPICalculator}
            />

            <Route
              path="/calculator/fair-market-pe"
              exact
              component={FairMarket}
            />
            <Route
              path="/calculator/wellhead-gas-price"
              exact
              component={WellheadGasPrice}
            />
            <Route
              path="/media/analystbriefing/:title"
              component={MediaDetail}
            />
            <Route path="/sector/omc" component={SectorOMC} />
          </Switch>
        </Router>
      </Currentprice.Provider>
    </>
  );
}

export default App;
export { Currentprice };
